import { render, staticRenderFns } from "./AddTransferStoreForm.vue?vue&type=template&id=45da57fc&"
import script from "./AddTransferStoreForm.vue?vue&type=script&lang=js&"
export * from "./AddTransferStoreForm.vue?vue&type=script&lang=js&"
import style0 from "./AddTransferStoreForm.vue?vue&type=style&index=0&id=45da57fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports